<script >
import Chart from 'chart.js/auto';
import { onBeforeUnmount, onMounted, ref, watch } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  chart: {
    type: Object,
    required: true
  },
  height: {
    type: Number,
    default: 150
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const canvasRef = ref(null);
  let chartInstance = null;
  const formatAxisNumber = value => {
    const normalized = Number(value);
    if (!Number.isFinite(normalized)) {
      return value;
    }
    return new Intl.NumberFormat('es-ES', {
      notation: Math.abs(normalized) >= 1000000 ? 'compact' : 'standard',
      compactDisplay: 'short',
      maximumFractionDigits: 1
    }).format(normalized);
  };
  const destroyChart = () => {
    if (chartInstance) {
      chartInstance.destroy();
      chartInstance = null;
    }
  };
  const renderChart = () => {
    destroyChart();
    if (!canvasRef.value || !props.chart?.chartData?.datasets?.length) {
      return;
    }
    chartInstance = new Chart(canvasRef.value, {
      type: 'line',
      data: props.chart.chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              maxRotation: 0,
              autoSkip: true,
              color: '#64748b',
              font: {
                size: 10
              }
            }
          },
          y: {
            beginAtZero: false,
            grid: {
              color: 'rgba(148, 163, 184, 0.16)'
            },
            ticks: {
              color: '#64748b',
              callback: formatAxisNumber,
              font: {
                size: 10
              },
              maxTicksLimit: 4
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: context => `${props.chart.title}: ${formatAxisNumber(context.parsed.y)}${props.chart.unitLabel ? ` ${props.chart.unitLabel}` : ''}`
            }
          }
        }
      }
    });
  };
  watch(() => props.chart, () => {
    renderChart();
  }, {
    deep: true
  });
  onMounted(() => {
    renderChart();
  });
  onBeforeUnmount(() => {
    destroyChart();
  });
  return {
    canvasRef
  };
};
export default __sfc_main;
</script>

<template>
    <div class="charting-fundamental-mini-chart">
        <div class="charting-fundamental-mini-chart__header">
            <div>
                <div class="charting-fundamental-mini-chart__title">{{ chart.title }}</div>
                <div v-if="chart.latestLabel" class="charting-fundamental-mini-chart__latest">{{ chart.latestLabel }}</div>
            </div>
            <span v-if="chart.unitLabel" class="charting-fundamental-mini-chart__unit">{{ chart.unitLabel }}</span>
        </div>
        <div class="charting-fundamental-mini-chart__canvas" :style="{ height: `${height}px` }">
            <canvas ref="canvasRef" />
        </div>
    </div>
</template>

<style scoped>
.charting-fundamental-mini-chart {
    border: 1px solid var(--charting-b-border-color, rgba(148, 163, 184, 0.18));
    border-radius: 1rem;
    background: var(--charting-b-panel-bg-strong, rgba(255, 255, 255, 0.92));
    padding: 0.85rem 1rem;
}

.charting-fundamental-mini-chart__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.charting-fundamental-mini-chart__title {
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--p-text-color);
}

.charting-fundamental-mini-chart__latest {
    margin-top: 0.2rem;
    font-size: 0.74rem;
    color: var(--p-text-muted-color);
}

.charting-fundamental-mini-chart__unit {
    max-width: 5.5rem;
    border: 1px solid var(--charting-b-border-color, rgba(148, 163, 184, 0.18));
    border-radius: 999px;
    padding: 0.2rem 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.68rem;
    font-weight: 700;
    color: var(--p-text-muted-color);
}

.charting-fundamental-mini-chart__canvas {
    position: relative;
    min-height: 8rem;
}

.charting-fundamental-mini-chart__canvas canvas {
    width: 100%;
    height: 100%;
}
</style>
